import React from 'react';
import { CollapsibleContainer as Component } from '@vfuk/core-collapsible-container';
const CollapsibleContainer = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CollapsibleContainer;
